import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";
import EarlyAccessForm from "@/components/EarlyAccessForm";
import { ExpandableDisclaimer } from "@/components/Compliance";
import usePageMeta from "@/hooks/usePageMeta";

export default function EarlyAccess() {
  usePageMeta({
    title: "Join Early Access — Adviserz Market Intelligence Platform",
    description:
      "Register your interest in early access to the Adviserz market intelligence platform. No payment is collected and no investment or advisory service is being offered.",
    canonical: "https://adviserz.in/early-access",
  });

  return (
    <div className="min-h-screen bg-surface-base text-white">
      <SiteHeader />
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 spotlight" />
        <div className="absolute inset-0 grid-bg opacity-40 grid-radial-mask" />
        <div className="relative max-w-2xl mx-auto px-6 md:px-12 pt-36 md:pt-44 pb-24">
          <div className="overline mb-6 justify-center text-center">Early Access</div>
          <h1 className="text-center font-display font-medium text-[34px] md:text-5xl tracking-tighter leading-[1.08]">
            Join the early access list.
          </h1>
          <p className="mt-6 text-center text-zinc-400 max-w-md mx-auto leading-relaxed">
            The Adviserz platform is in development. Register your interest and we will notify you when access opens.
          </p>
          <EarlyAccessForm />
          <div className="mt-12">
            <ExpandableDisclaimer testid="early-access-disclaimer" />
          </div>
        </div>
      </section>
      <SiteFooter />
    </div>
  );
}
